var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-column-between basic-layout-v"},[_c('top-menu'),_c('div',{staticClass:"main-container"},[_c('keep-alive',[_vm._v("ß\n\t\t  "),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }